<template>
    <card>
        <template slot="header">
        <h3 class="card-title">Par où commencer ?</h3>
        </template>

        <tabs type="primary">
        <tab-pane label="Peamoni en quelques mots">
            <p>
                Moni est un outil de <b>suivi de portefeuille</b> et 
                <b>d'analyse de tendances</b> basé sur des indicateurs techniques.
                <br><br>
                Moni est dédié aux comptes PEA, US et cryptos, vous y trouverez la plupart 
                des valeurs sur lesquelles vous pouvez investir.
                <br><br>
                Basculez entre le mode crypto, le mode US et le mode PEA en utilisant le bouton dans la barre de navigation !
                <br><br>
                Vous pouvez découvrir de nouvelles valeurs via les <router-link class="pointer text-primary" tag="b" to="/screeners">screeners</router-link>, 
                étudier en détails leurs historiques dans le menu <router-link class="pointer text-primary" tag="b" to="/instruments">instruments</router-link>, 
                et y renseigner vos positions actuelles pour suivre l'évolution de votre portefeuille.
                <br><br>
                D'ici quelques jours, ce tutorial sera remplacé par un graphique hebdomadaire de suivi
                de la performance de votre compte.
                <br><br>
                <i>Les informations affichées ne constituent pas de conseils d'achats et 
                vous êtes seul responsable de vos trades/investissements.</i>
            </p>
        </tab-pane>

        <tab-pane label="Fonctionnement">
            <p>
                Pour suivre votre portefeuille, vous devez renseigner deux éléments : 
                <ul>
                    <li class="mt-2">
                        <h6>Vos positions</h6>
                        Depuis le menu <router-link class="pointer text-primary" tag="b" to="/instruments">instruments</router-link>, vous pouvez gérer votre position sur une valeur
                        en renseignant le nombre de titres, le prix de revient unitaire et, si vous en utilisez,
                        le seuil de déclenchement du stop.
                    </li>
                    <li class="mt-2">
                        <h6>Le cash disponible</h6>
                        Cette valeur est modifiable depuis le <router-link class="pointer text-primary" tag="b" to="/pages/user">profil</router-link> du compte. Elle permet de 
                        calculer automatiquement votre pourcentage de liquidité, et chaque dimanche soir, 
                        la somme totale de votre portefeuille (positions + cash), afin d'afficher un suivi graphique.
                    </li>
                </ul>
            </p>
            <p>
                Des filtres ont été appliqués en fonction de votre expérience, pour vous aider à cibler des valeurs.
                Vous pouvez à tout moment les modifier à partir de votre <router-link class="pointer text-primary" tag="b" to="/pages/user">profil</router-link>.
            </p>
        </tab-pane>

        <tab-pane label="Des questions ?">
            <p>
                Besoin d'aide ? Pas de panique ... 
                <ul>
                    <li class="mt-2">
                        <h6>Accédez à la <router-link class="pointer text-primary" tag="b" to="/faq">Foire aux Questions</router-link></h6>
                        La FAQ est allimentée petit à petit afin de répondre à l'ensemble des questions qui
                        se posent sur Peamoni, et pour permettre de prendre en main cet outil encore plus rapidement.
                    </li>
                    <li class="mt-2">
                        <h6>Rendez-vous sur <a href="https://twitter.com/moni_app" class="text-primary font-weight-bold">Twitter</a></h6>
                        Si vous ne trouvez pas les informations recherchées dans la FAQ, contactez nous directement
                        sur Twitter.
                        <br><br>
                        Nous en profiterons pour mettre à jour la Foire aux Questions ;)
                    </li>
                </ul>
            </p>
        </tab-pane>
        </tabs>
    </card>
</template>
<script>
import { TabPane, Tabs } from 'src/components';
import { mapGetters } from 'vuex';

export default {
  components: {
      Tabs,
      TabPane
  },
  computed: {
    ...mapGetters({
      mode: 'auth/mode',
    }),
  },
};
</script>
<style>
.pointer {
    cursor: pointer;
}
</style>
